import type {
  MatchDetailDto,
  PickemDto,
  TeamMatchDetailDto,
} from '@/api/backoffice-schemas';

export const isDailyPickem = (pickem: PickemDto) => !pickem.pickemTournament;

export function getTeamNames(
  teamMatches: TeamMatchDetailDto[] | null
): [string | null, string | null] {
  if (!teamMatches || teamMatches.length < 2) {
    return [null, null];
  }
  return [teamMatches[0].team?.name ?? null, teamMatches[1].team?.name ?? null];
}

export const getWinningTeamId = (match: MatchDetailDto | undefined) => {
  if (!match) {
    return null;
  }

  const teams = match?.teamMatches ?? [];

  const winningTeamId = teams.find(
    (t) => t.team?.externalId === match?.winner?.externalId
  )?.teamId;

  return winningTeamId;
};

export const getPlayerRankInLeaderboard = ({
  indexOnCurrentPage: index,
  perPagePlayers,
  currentPage,
}: {
  indexOnCurrentPage: number;
  perPagePlayers: number;
  currentPage: number;
}) => {
  return (currentPage - 1) * perPagePlayers + index + 1;
};
